<script>
import errorIcon from '@/assets/images/icons/circle-cross.svg?inline'

export default {
  name: 'AccesDenied',
  components: {
    errorIcon
  },
  metaInfo: {
    title: 'Доступ запрещен'
  }
}
</script>
<template>
  <div class="error-card">
    <error-icon />
    <div>
      <h1>403</h1>
      <p>
        У вас недостаточно прав на просмотр этой страницы.<br>
        Вы можете запросить права у администратора или обратиться в
        <router-link
          :event="''"
          :to="{
            name: 'Main'
          }"
        >
          контакты
        </router-link>
      </p>
    </div>
  </div>
</template>